/**
 * This is the list of countries the registration form allows the user to select.
 *
 * This is hard coded to keep things simple and fast for now but this could be
 * converted to an async HTTP API call, or some kind of config reader later if
 * its ever needed.
 */
export const getCountryList = () => {
    return [
        { label: "Australia", value: "AUS" },
        { label: "Austria", value: "AUT" },
        { label: "Canada", value: "CAN" },
        { label: "France", value: "FRA" },
        { label: "Germany", value: "DEU" },
        { label: "Ireland", value: "IRL" },
        { label: "Italy", value: "ITA" },
        { label: "Mexico", value: "MEX" },
        { label: "Netherlands", value: "NLD" },
        { label: "New Zealand", value: "NZL" },
        { label: "Philippines", value: "PHP" },
        { label: "Poland", value: "POL" },
        { label: "Spain", value: "ESP" },
        { label: "United Kingdom", value: "GBR" },
        { label: "United States", value: "USA" },
        { label: "Other", value: "OTHER" },
    ];
};
